<template>
  <section :id="sectionId" v-editable="blok" feature-tabs :data-spacing="blok?.spacing || 'open'">
    <div class="container">
      <div class="row section-header">
        <h2 v-if="blok?.title" class="section-title">
          <StoryblokRichText :doc="blok.title" />
        </h2>

        <div v-if="blok?.description" class="section-description">
          <StoryblokRichText :doc="blok.description" />
        </div>
        <div v-if="blok?.buttons && blok?.buttons?.length > 0" class="row row-footer">
          <div class="section-buttons">
            <StoryblokComponent v-for="button in blok.buttons" :key="button._uid" :blok="button" />
          </div>
        </div>
      </div>
      <div v-if="blok?.tabs && blok?.tabs?.length > 0" class="row">
        <div class="section-tabs">
          <UTabs :items="blok?.tabs" orientation="vertical" :ui="ui.tabs">
            <template #default="{ item: tab, index, selected }">
              <div v-editable="tab" class="tab-button" :class="[selected && 'tab-selected']">
                <h3 class="tab-title">
                  <StoryblokRichText :doc="tab.title" />
                </h3>
                <div class="tab-description">
                  <StoryblokRichText :doc="tab.description" />
                </div>
                <div v-if="tab?.icon?.filename" class="tab-icon">
                  <img :src="optimizeImage(tab.icon.filename)" :alt="`${index} Feature Tab Icon`" loading="lazy" />
                </div>
                <div class="tab-arrow"></div>

                <div class="tab-content">
                  <StoryblokComponent :key="index" :blok="tab" />
                </div>
              </div>
            </template>
            <template #icon="{ item: tab, selected }"> <span class="tab-btn-bg" :style="[backgroundGradient(tab)]"></span> </template>
            <template #item="{ item: tab, index, selected }">
              <StoryblokComponent :key="index" :blok="tab" />
            </template>
          </UTabs>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
  const props = defineProps({ blok: Object });

  const ui = {
    tabs: {
      wrapper: "flex flex-col lg:flex-row items-stretch gap-16",
      container: "tab-panels",
      base: "h-full",
      list: {
        base: "relative tab-list",
        background: "transparent",
        width: "w-auto",
        marker: {
          base: "hidden",
        },
        tab: {
          base: "tab-button-wrapper",
          background: "",
          active: "text-gray-900 dark:text-white tab-selected",
          inactive: "text-gray-500 dark:text-gray-400",
          height: "h-auto",
          padding: "px-3",
          size: "text-sm",
          font: "font-medium",
          rounded: "rounded-md",
          shadow: "",
          icon: "w-4 h-4 flex-shrink-0 me-2",
        },
      },
    },
  };

  const sectionId = computed(() => {
    if (props.blok?.sectionId) return textSlugify(props.blok?.sectionId);
    return props.blok?._uid;
  });

  const backgroundGradient = (tab) => {
    if (!tab.background_gradient) return null;
    return {
      background: tab.background_gradient,
    };
  };
</script>
<style src="~/assets/scss/section/feature-tabs.scss" lang="scss"></style>
